<h2>Выводы</h2>
<div class="container withdraw-content">
  <div class="withdraw-data">
    <mat-form-field appearance="standard">
      <mat-label>Фильтр</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Например статус или способ" #input>
    </mat-form-field>

    <ng-container *ngIf="isGoFast then goFastTable; else hltvTable"></ng-container>

    <ng-template #goFastTable>
      <mat-table [dataSource]="userWithdrawals" class="table withdraw-table" matSort>

        <!-- orderId Column -->
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.id}} </mat-cell>
        </ng-container>

        <!-- state Column -->
        <ng-container matColumnDef="state">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Статус</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="status-box" [ngClass]="element.statusText"><span
              matTooltip="{{fastOfferOrderStatusEnum[element.state]
              ? (fastOfferOrderStatusEnum[element.state] + '   ' +((element.error || element.reason) ?? ''))
              : (element.error || element.reason || '')
            }}"
              matTooltipPosition="above">
            {{(element.statusText) | uppercase}}
          </span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- state Column -->
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Сумма</mat-header-cell>
          <mat-cell *matCellDef="let element">
                <span
                  matTooltip="{{element.amount | fastCoinsToDollar}}"
                  matTooltipPosition="above"
                  [matTooltipDisabled]="!isGoFast"
                >{{element.amount / 100 | number }}</span></mat-cell>
        </ng-container>

        <!-- system Column -->
        <ng-container matColumnDef="system">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Система</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span>{{element.system}}</span>
            <span *ngIf="element.fast_deliver === false" matTooltip="player-to-player">&nbsp;P2P</span>
          </mat-cell>
        </ng-container>

        <!-- seller Column -->
        <ng-container matColumnDef="seller-wallet">
          <mat-header-cell *matHeaderCellDef>Seller / Wallet</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.seller || element.wallet; else empty">
              <ng-container *ngIf="element.seller != null">
                <span class="ellipsis-text"><a [routerLink]="['/user/', element.seller]">{{element.seller}}</a></span>
              </ng-container>
              <ng-container *ngIf="element.wallet">
                <div class="email-container">
                  <a class="link" [routerLink]="['/payouts/wallet/', element.wallet]">
                    <span class="text-overflow">{{element.wallet}}</span></a>
                  <mat-icon class="icon"
                            matTooltip="Нажми чтобы скопировать"
                            matTooltipPosition="above"
                            (click)="clipboard.copy(element.wallet)">content_copy
                  </mat-icon>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #empty>
              <span>-</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Предмет</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.name else withdrawByMoney">
              <div class="item-container"
                   matTooltip="{{element.name}}"
                   matTooltipPosition="above">
                <div class="img-box" *ngIf="element.img">
                  <img class="image" [src]="element.img" alt="item-icon">
                </div>
                <div class="item-name text-overflow">{{element.name}}
                </div>
              </div>
            </ng-container>
            <ng-template #withdrawByMoney>
              <img src="../../../../../assets/images/fastcoin.svg" alt="fastcoin">
              <span>&nbsp; Fast Coins</span>
            </ng-template>
          </mat-cell>
        </ng-container>

        <!-- timestamp Column -->
        <ng-container matColumnDef="timestamp">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Дата</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.timestamp | date: 'dd.MM.yy HH:mm:ss'}} </mat-cell>
        </ng-container>

        <!-- comment Column -->
        <ng-container matColumnDef="comment">
          <mat-header-cell *matHeaderCellDef>Коммент</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.comment else emptyComment">
              <mat-icon class="comment-icon" matTooltip="{{element.comment}}" matTooltipPosition="above">info</mat-icon>
            </ng-container>
            <ng-template #emptyComment>-</ng-template>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="withdrawColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: withdrawColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <mat-paginator [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
    </ng-template>

    <ng-template #hltvTable>
      <div>
        <mat-table [dataSource]="userWithdrawals" class="table withdraw-table" matSort>

          <!-- orderId Column -->
          <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>ID</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.id}} </mat-cell>
          </ng-container>

          <!-- createdAt Column -->
          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef>Создан</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.createdAt | date: 'dd.MM.yy HH:mm:ss'}} </mat-cell>
          </ng-container>

          <!-- approved Column -->
          <ng-container matColumnDef="approved">
            <mat-header-cell *matHeaderCellDef>Подтвержден</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.approved ? 'Да' : 'Нет'}} </mat-cell>
          </ng-container>

          <!-- userInventoryItemId Column -->
          <ng-container matColumnDef="userInventoryItemId">
            <mat-header-cell *matHeaderCellDef>Предмет</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.userInventoryItemId}} </mat-cell>
          </ng-container>

          <!-- amount Column -->
          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef>Сумма</mat-header-cell>
            <mat-cell *matCellDef="let element"><span>{{element.amount / 100 | currency: 'USD'}}</span></mat-cell>
          </ng-container>

          <!-- state Column -->
          <ng-container matColumnDef="state">
            <mat-header-cell *matHeaderCellDef>Статус</mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.state}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="withdrawColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: withdrawColumns;"></mat-row>

          <div class="empty-data" *matNoDataRow>
            <p>Данные отсутствуют</p>
          </div>
        </mat-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <mat-paginator [pageSizeOptions]="[20, 50, 100]"></mat-paginator>
      </div>
    </ng-template>

  </div>
</div>
